import { reader } from '@woonstad/helpers-utils';

export interface FormattedFile {
  mimeType: string;
  fileName: string;
  file: string;
}

// Function that formats the files to something we can send to the API in JSON format
// It returns the file as base64 string
// It returns the file name
// It returns the mime type of the file
export async function formatFiles(files: File[]): Promise<FormattedFile[]> {
  let formattedFiles: FormattedFile[] = [];

  try {
    formattedFiles = await Promise.all(files.flatMap(async (file) => {
      const loadedFile = await reader(file);

      return ({
        fileName: file.name,
        mimeType: file.type,
        file: dataUriToBase64(loadedFile),
      });
    }));
  } catch (error) {
    console.error('Something went wrong while formatting images: ', error);
  }

  return formattedFiles;
}

// DataUri to base64
export function dataUriToBase64(dataUri: string): string {
  return dataUri
    .replace('data:', '')
    .replace(/^.+,/, '');
}

// Check if every file we have in th uploaded files are of type File
export function filesAreFiles(files: Array<File | unknown>): boolean {
  return files.every((file) => file instanceof File);
}
